__turbopack_context__.v({
  "badge": "AGxX8q_badge",
  "marker": "AGxX8q_marker",
  "tooltipButton": "AGxX8q_tooltipButton",
  "tooltipContent": "AGxX8q_tooltipContent",
  "tooltipDivider": "AGxX8q_tooltipDivider",
  "tooltipHeader": "AGxX8q_tooltipHeader",
});
